import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, getSortState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './bursa-api-order.reducer';
import { IBursaAPIOrder } from 'app/shared/model/bursa-api-order.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const BursaAPIOrder = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const bursaAPIOrderList = useAppSelector(state => state.bursaAPIOrder.entities);
  const loading = useAppSelector(state => state.bursaAPIOrder.loading);
  const totalItems = useAppSelector(state => state.bursaAPIOrder.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const { match } = props;

  return (
    <div>
      <h2 id="bursa-api-order-heading" data-cy="BursaAPIOrderHeading">
        <Translate contentKey="comexApp.bursaAPIOrder.home.title">Bursa API Orders</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="primary" outline onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="comexApp.bursaAPIOrder.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="comexApp.bursaAPIOrder.home.createLabel">Create new Bursa API Order</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {bursaAPIOrderList && bursaAPIOrderList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('endpointURL')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.endpointURL">Endpoint URL</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('memberShortName')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.memberShortName">Member Short Name</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('uuid')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.uuid">Uuid</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('serialNumber')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.serialNumber">Serial Number</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('bidOption')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.bidOption">Bid Option</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('stbOption')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.stbOption">Stb Option</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('otcOption')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.otcOption">Otc Option</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('productCode')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.productCode">Product Code</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('purchaseType')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.purchaseType">Purchase Type</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('clientName')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.clientName">Client Name</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('currency')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.currency">Currency</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('bidValue')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.bidValue">Bid Value</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('valueDate')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.valueDate">Value Date</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('tenor')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.tenor">Tenor</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('otcCounterParty')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.otcCounterParty">Otc Counter Party</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('otcMurabaha')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.otcMurabaha">Otc Murabaha</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('otcMurabahaValue')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.otcMurabahaValue">Otc Murabaha Value</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('ecertNo')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.ecertNo">Ecert No</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('errorCode')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.errorCode">Error Code</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('errorMsg')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.errorMsg">Error Msg</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('statusCode')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.statusCode">Status Code</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('statusMessage')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.statusMessage">Status Message</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('quotationId')}>
                  <Translate contentKey="comexApp.bursaAPIOrder.quotationId">Quotation Id</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {bursaAPIOrderList.map((bursaAPIOrder, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${bursaAPIOrder.id}`} color="link" size="sm">
                      {bursaAPIOrder.id}
                    </Button>
                  </td>
                  <td>{bursaAPIOrder.endpointURL}</td>
                  <td>{bursaAPIOrder.memberShortName}</td>
                  <td>{bursaAPIOrder.uuid}</td>
                  <td>{bursaAPIOrder.serialNumber}</td>
                  <td>{bursaAPIOrder.bidOption}</td>
                  <td>{bursaAPIOrder.stbOption}</td>
                  <td>{bursaAPIOrder.otcOption}</td>
                  <td>{bursaAPIOrder.productCode}</td>
                  <td>{bursaAPIOrder.purchaseType}</td>
                  <td>{bursaAPIOrder.clientName}</td>
                  <td>{bursaAPIOrder.currency}</td>
                  <td>{bursaAPIOrder.bidValue}</td>
                  <td>{bursaAPIOrder.valueDate}</td>
                  <td>{bursaAPIOrder.tenor}</td>
                  <td>{bursaAPIOrder.otcCounterParty}</td>
                  <td>{bursaAPIOrder.otcMurabaha}</td>
                  <td>{bursaAPIOrder.otcMurabahaValue}</td>
                  <td>{bursaAPIOrder.ecertNo}</td>
                  <td>{bursaAPIOrder.errorCode}</td>
                  <td>{bursaAPIOrder.errorMsg}</td>
                  <td>{bursaAPIOrder.statusCode}</td>
                  <td>{bursaAPIOrder.statusMessage}</td>
                  <td>{bursaAPIOrder.quotationId}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${bursaAPIOrder.id}`} size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      &nbsp;
                      <Button
                        tag={Link}
                        to={`${match.url}/${bursaAPIOrder.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      &nbsp;
                      <Button
                        tag={Link}
                        to={`${match.url}/${bursaAPIOrder.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="comexApp.bursaAPIOrder.home.notFound">No Bursa API Orders found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={bursaAPIOrderList && bursaAPIOrderList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default BursaAPIOrder;
